<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item active"><strong>Regions</strong></li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="refresh()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">
  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading regions&hellip;
  </div>

  <ng-container *ngIf="!loading">
    <div class="alert alert-secondary" *ngIf="regions.length === 0">
      No regions containing parks with irrigation controllers found.
    </div>

    <div class="regions-grid" *ngIf="regions.length > 0">
      <section class="region-card" *ngFor="let region of regions">
           <div class="region-card__header" (click)="viewRegion(region)" role="button" tabindex="0"
             (keydown.enter)="viewRegion(region)" [attr.aria-label]="'View ' + region.name">
          <div>
            <div class="region-card__name">{{ region.name }}</div>
            <div class="region-card__summary">
              {{ region.parkCount }} Park{{ region.parkCount === 1 ? '' : 's' }} &middot;
              {{ region.controllerCount }} Irrigation Controller{{ region.controllerCount === 1 ? '' : 's' }}
            </div>
          </div>
          <i class="fa fa-map-marker-alt region-card__icon" aria-hidden="true"></i>
        </div>
        <div class="region-children">
          <div class="region-child" (click)="viewPark(park)" role="button" tabindex="0"
               (keydown.enter)="viewPark(park)" *ngFor="let park of region.parks">
            <div class="region-child__icon" aria-hidden="true">
              <i class="fa fa-tree"></i>
            </div>
            <div class="region-child__content">
              <strong>{{ park.name }}</strong>
              <span class="region-child__stat">
                <strong>{{ park.controllerCount }}</strong> Controllers
                <span class="region-child__alarm" *ngIf="park.activeAlarmCount > 0" role="alert">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                  {{ park.activeAlarmCount }} alarm{{ park.activeAlarmCount === 1 ? '' : 's' }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
</div>
